import React from 'react';
import { useIntl } from 'react-intl';
import cn from 'classnames';

import { Icon } from 'components';
import globalMsg from 'messages';

import Arrow from 'assets/svg/arrow.svg';
import settingsIcon from 'assets/svg/setting-betslip.svg';
import './settingsToggler.scss';

interface OwnProps {
    isOpen: boolean;
    onClickHandler: () => void;
}

type Props = OwnProps;

const SettingsToggler: React.FC<Props> = ({ onClickHandler, isOpen }) => {
    const { formatMessage } = useIntl();

    return (
        <div
            styleName="container"
            title={formatMessage(globalMsg.showSettings)}
            onClick={onClickHandler}
        >
            <div styleName="stub">
                <div styleName="caret-wrapper">
                    <Icon
                        styleName={cn('caret', {
                            'is-open': isOpen,
                        })}
                        glyph={Arrow}
                    />
                </div>
                <Icon
                    styleName={cn('icon', {
                        'is-open': isOpen,
                    })}
                    glyph={settingsIcon}
                />
            </div>
        </div>
    );
};

export default SettingsToggler;
